import { render, staticRenderFns } from "./EmptyAccommodationsTable.vue?vue&type=template&id=f015c31c&"
import script from "./EmptyAccommodationsTable.vue?vue&type=script&lang=js&"
export * from "./EmptyAccommodationsTable.vue?vue&type=script&lang=js&"
import style0 from "./EmptyAccommodationsTable.vue?vue&type=style&index=0&id=f015c31c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports